import { authHeader, BASE_URL, handleResponse } from '@helpers/api';

function requestIntegration(data) {
    const requestOptions = {
        method: 'POST',
        headers: authHeader(),
        body: JSON.stringify(data),
    };
    return fetch(`${BASE_URL}api/integrations/requests`, requestOptions).then(handleResponse);
}

export const integrationRequestsService = {
    requestIntegration,
};
